import React from 'react'
import ConnectIcon from '../../../images/connect.svg'
import DatabaseIcon from '../../../images/database.svg'

export const DatabaseConnection: React.FC = () => {
  return (
    <div className='onlinepbx__help'>
      <div className='onlinepbx__head'>
        <div className='onlinepbx__container'>
          <h2 className='onlinepbx__content__header__center'>Помощь</h2>
          <div className='onlinepbx__help__datacon'>
            <div className='onlinepbx__help__datacon__block'>
              <ConnectIcon className='onlinepbx__help__datacon__icon' />
              <div className='onlinepbx__help__datacon__right'>
                <div className='onlinepbx__help__datacon__header'>Подключение</div>
                <div className='onlinepbx__help__datacon__description'>Для удалённого подключения мы используем Rudesktop</div>
                <div className='onlinepbx__help__datacon__button'>
                  <a className='onlinepbx__help__datacon__link' target='_blank' href='https://rudesktop.ru/downloads'>
                    Скачать программу
                  </a>
                </div>
              </div>
            </div>
            <div className='onlinepbx__help__datacon__block'>
              <DatabaseIcon className='onlinepbx__help__datacon__icon' />
              <div className='onlinepbx__help__datacon__right'>
                <div className='onlinepbx__help__datacon__header'>База знаний</div>
                <div className='onlinepbx__help__datacon__description'>
                  Если есть вопросы по работе сервиса, вы можете воспользоваться инструкциями.
                </div>
                <div className='onlinepbx__help__datacon__button'>
                  <a
                    className='onlinepbx__help__datacon__link'
                    target='_blank'
                    href='https://onlinepbx.evateam.ru/docs/docs/CmfProject:e6966c84-48a9-11ee-848f-00161e050156#baza-znanij-online-pbx'
                  >
                    Перейти в базу знаний
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DatabaseConnection
